import { render, staticRenderFns } from "./T1PortaleTurystyczneContent.vue?vue&type=template&id=35749506&scoped=true&"
import script from "./T1PortaleTurystyczneContent.vue?vue&type=script&lang=js&"
export * from "./T1PortaleTurystyczneContent.vue?vue&type=script&lang=js&"
import style0 from "./T1PortaleTurystyczneContent.vue?vue&type=style&index=0&id=35749506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35749506",
  null
  
)

export default component.exports